import { Injectable } from '@angular/core';
import { marked } from 'marked';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  constructor() {}

  /**
   * Compiles markdown string to HTML
   * @param markdown - The markdown string to compile
   * @returns The compiled HTML string
   */
  compile(markdown: string): string {
    if (!markdown) {
      return '';
    }
    
    return marked.parse(markdown) as string;
  }
}
